import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { errorsMapping } from '../../constants/constants.js';
import { GET_ORDER_BY_TOKEN } from '../../operations/queries/get-order-by-token.js';

const useGetOrderByToken = ()=>{
    const [orderByToken, { called , loading , data , error: error1  }] = useLazyQuery(GET_ORDER_BY_TOKEN, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
        }
    });
    const getOrderByToken = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(token, onCompleted) {
            if (token) {
                const result = yield orderByToken({
                    variables: {
                        token
                    }
                });
                if (result.data !== null) {
                    onCompleted();
                }
            }
        });
        return function(token, onCompleted) {
            return _ref.apply(this, arguments);
        };
    }(), [
        orderByToken
    ]);
    const queryResults = React.useMemo(()=>({
            data: data || undefined,
            called,
            loading,
            error: error1
        })
    , [
        called,
        data,
        error1,
        loading
    ]);
    return [
        getOrderByToken,
        queryResults
    ];
};

export { useGetOrderByToken };
//# sourceMappingURL=use-get-order-by-token.js.map
